import React, { FC } from 'react'
import { cn } from '../../../shared/utils'

import styles from '../Story.module.scss'
import { StoryContext } from '../StoryContext'
import { TStory } from '../types'

type TStoryContainerProps = {
  className?: string
  story: TStory
  storyRef?: React.RefObject<HTMLDivElement>
}

export const StoryContainer: FC<TStoryContainerProps> = (props) => {
  return (
    <StoryContext.Provider value={props.story}>
      <div className={cn(styles.container, props.className, {
        [styles.pinned]: props.story.pinned
      })} ref={props.storyRef}>
        {props.children}
      </div>
    </StoryContext.Provider>
  )
}
